import api from '@pray/shared/utils/api';

import type { SeedSettingsResponse, SeedTrackingHeaderSource } from './types';

const SETTINGS_URL = '/web/studio/admin/seed-emails/settings';

export type SaveSettingsParams = {
  /** Only the sources to write. The server leaves every source it is not given untouched. */
  trackingHeaders: { source: SeedTrackingHeaderSource; name: string }[];
};

/**
 * Saves the tracking header names it is given, one entry per data source. A name that is not an
 * RFC 9110 token, or one SendGrid already owns, answers 400 `seed_settings_invalid_header_name`
 * with a sentence in `info` that names the source; nothing is written then.
 *
 * Renaming does not touch past runs: every run keeps the header names it was sent with.
 */
export async function putSettings({ trackingHeaders }: SaveSettingsParams) {
  const res = await api.executePutRequest<{ data: SeedSettingsResponse }>(SETTINGS_URL, {
    tracking_headers: trackingHeaders.map(({ source, name }) => ({ source, name })),
  });
  return res.data.data;
}
